import _ from "lodash"
import { getSession } from "../../helpers/AuthType/authService"

export const unitTypes = () => {
  let {
    definitions: { unitTypes: object },
  } = getSession()

  let options = []
  let counter = 0

  options[counter] = { value: "", label: "Unit Type" }
  counter++

  _.forOwn(object, function (value, key) {
    options[counter] = { value: key, label: value }
    counter++
  })

  return options
}

export const getLicensedStates = () => {
  let {
    definitions: { licensedStates: object },
  } = getSession()

  let options = []
  let counter = 0

  _.forOwn(object, function (value, key) {
    options[counter] = { value: key, label: value }
    counter++
  })

  return options
}

export const getStates = () => {
  let {
    definitions: { states: object },
  } = getSession()
  let options = []
  let counter = 0

  _.forOwn(object, function (value, key) {
    options[counter] = { value: key, label: value }
    counter++
  })

  return options
}

export const getIncomeTypes = () => {
  let {
    definitions: { incometype: object },
  } = getSession()
  let options = []
  let counter = 0

  _.forOwn(object, function (value, key) {
    options[counter] = { value: key, label: value }
    counter++
  })

  return options
}

export const getHomeOwnership = () => {
  let {
    definitions: { homeownership: object },
  } = getSession()
  let options = []
  let counter = 0

  _.forOwn(object, function (value, key) {
    options[counter] = { value: key, label: value }
    counter++
  })

  return options
}

export const getResidencyStatus = () => [
  { value: 1, label: "Owner" },
  { value: 2, label: "Renting" },
]

export const getResidencyLength = () => [
  { value: 1, label: "Less Than 2 Years" },
  { value: 2, label: "More Than 2 Years" },
]

export const getIsJoint = () => {
  let {
    app: { coapplicant },
  } = getSession()

  if (!_.isUndefined(coapplicant) && !_.isNull(coapplicant)) {
    let { firstname, lastname } = coapplicant
    return [
      { value: 0, label: "No" },
      { value: 1, label: "Yes - (" + firstname + " " + lastname + ")" },
      { value: 2, label: "Yes - (Replace and Add)" },
    ]
  } else {
    return [
      { value: 0, label: "No" },
      { value: 1, label: "Yes" },
    ]
  }
}

export const getIsDual = () => [
  { value: 0, label: "No" },
  { value: 1, label: "Yes" },
]

export const getContractTypes = () => {
  let {
    definitions: { contractTypes: object },
  } = getSession()
  let options = []
  let counter = 0

  if (_.isEmpty(object)) return options

  _.forOwn(object, function (value, key) {
    options[counter] = {
      value: _.isNull(value.id) ? 0 : value.id,
      label: value.label,
    }
    counter++
  })

  return options
}

export const getPaperType = () => [
  { value: 1, label: "Digital Contract" },
  { value: 2, label: "Paper Contract" },
]

export const getContractCategories = () => {
  let {
    definitions: { contractCategory: object },
  } = getSession()

  let options = []
  let counter = 0

  if (_.isEmpty(object)) return options

  _.forOwn(object, function (value, key) {
    options[counter] = { value: key, label: value }
    counter++
  })

  return options
}

export const getIsSameAsCash = () => [
  { value: 0, label: "No" },
  { value: 1, label: "Yes" },
]

export const getSameAsCash = () => {
  let {
    definitions: { sac: object },
  } = getSession()

  let options = []
  let counter = 0

  if (_.isEmpty(object)) return options

  _.forOwn(object, function (value, key) {
    options[counter] = { value: key, label: value }
    counter++
  })

  return options
}

export const getAcceptAchTerms = () => [
  { value: 0, label: "Decline" },
  { value: 1, label: "Accept" },
]

export const getAchCC = () => [
  { value: 1, label: "Debit Card" },
  { value: 2, label: "ACH (checking or Savings)" },
]

export const getBillingApplicant = () => {
  let {
    app: { coapplicant },
  } = getSession()

  return !_.isUndefined(coapplicant)
    ? [
        { value: 1, label: "Applicant" },
        { value: 2, label: "Co-Applicant" },
      ]
    : [{ value: 1, label: "Applicant" }]
}

export const getCcType = () => {
  let {
    definitions: { ccType: object },
  } = getSession()

  let options = []
  let counter = 0

  if (_.isEmpty(object)) return options

  _.forOwn(object, function (value, key) {
    options[counter] = {
      value: key,
      label: value,
      key:
        key == "AE"
          ? "amex"
          : key == "JCB"
          ? _.toLower(key)
          : key == "MC"
          ? _.toLower(value.replaceAll(" ", ""))
          : _.toLower(value),
    }
    counter++
  })

  return options
}

export const getCcMonths = () => {
  let {
    definitions: { ccMonths: object },
  } = getSession()

  let options = []
  let counter = 0

  if (_.isEmpty(object)) return options

  _.forOwn(object, function (value, key) {
    options[counter] = { value: key, label: value }
    counter++
  })

  return options
}

export const getCcYears = () => {
  let {
    definitions: { ccYears: object },
  } = getSession()

  let options = []
  let counter = 0

  if (_.isEmpty(object)) return options

  _.forOwn(object, function (value, key) {
    options[counter] = { value: key, label: value }
    counter++
  })

  return options
}

export const getBankAccountType = () => {
  let {
    definitions: { bankAccountType: object },
  } = getSession()

  let options = []
  let counter = 0

  if (_.isEmpty(object)) return options

  _.forOwn(object, function (value, key) {
    options[counter] = { value: key, label: value }
    counter++
  })

  return options
}

export const getContractLanguage = () => {
  let {
    definitions: { spanishInstallmentStates, language },
    app: {
      applicant: { state },
    },
  } = getSession()

  if (
    !_.isUndefined(
      _.find(spanishInstallmentStates, function (o) {
        return o == state
      })
    )
  )
    return [
      { value: 1, label: "English" },
      { value: 2, label: "Spanish" },
    ]

  return [{ value: 1, label: "English" }]
}

export const getSigningExperience = () => {
  let {
    merchant: { sms_docusign },
  } = getSession()

  let options = [
    { value: 1, label: "Sign Contract Via Device (Face-to-Face)" },
    { value: 0, label: "Email Contract" },
  ]

  if (sms_docusign)
    options = _.concat(options, { value: 2, label: "Email + SMS Contract" })

  return options
}

export const getDocumentTypes = () => [
  { value: 'creditApp', label: "Credit Application" },
  { value: 'purchAgreement', label: "Purchase Agreement" },
  { value: 'merchant email', label: "Merchant Email" },
  { value: 'paper contract', label: "Paper Contract" },
]
